import { registerComponent } from '../app'
import { OPEN_AFTERPAY, CLOSE_AFTERPAY } from '../events'

const AfterpayToggle = (scope, el) => {

    const props = {
        loadedClass: "overlay__hidden",
        openClass: "overlay__visible"
    };
    scope.on(OPEN_AFTERPAY, () => {
        el.classList.add(props.openClass)
    })

    scope.on(CLOSE_AFTERPAY, () => {
        el.classList.remove(props.openClass)
    })

    el.addEventListener('click', () => {
        el.classList.contains(props.openClass) ? scope.emit(CLOSE_AFTERPAY) : scope.emit(OPEN_AFTERPAY)
    })
}

registerComponent('afterpay-toggle', AfterpayToggle)
